import { Item, ItemActions, ItemContent, ItemMedia } from '@/components/ui/item'
import { Skeleton } from '@/components/ui/skeleton'

export function PackagingSuppliersStatCardSkeleton() {
  return (
    <Item variant='outline' size='xs' className='items-center'>
      <ItemMedia variant='icon' className='self-center'>
        <Skeleton className='size-4 rounded-sm' />
      </ItemMedia>
      <ItemContent className='min-w-0 gap-1'>
        <Skeleton className='h-3 w-24' />
        <Skeleton className='h-3 w-14' />
      </ItemContent>
      <ItemActions className='shrink-0'>
        <Skeleton className='h-6 w-10' />
      </ItemActions>
    </Item>
  )
}
